import { Typography, useTheme } from "@mui/material";
import type { FC } from "react";

interface DateLineProps {
	text: string;
}

export const DateLine: FC<DateLineProps> = ({ text }) => {
	const theme = useTheme();

	return (
		<Typography fontSize={11} color={theme.palette.grey[500]} noWrap>
			{text}
		</Typography>
	);
};
